import {arrowUpSvg as Icon__small__arrowUpSvg} from '../Icon__small/Icon__small--arrowUp.js';
import {arrowUpSvg as Icon__xsmall__arrowUpSvg} from '../Icon__xsmall/Icon__xsmall--arrowUp.js';
import {arrowUpSvg as Icon__xxsmall__arrowUpSvg} from '../Icon__xxsmall/Icon__xxsmall--arrowUp.js';

export var arrowUp = {
  name: 'arrowUp',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowUpSvg,
  alt: {
    Icon__small: Icon__small__arrowUpSvg,
    Icon__xsmall: Icon__xsmall__arrowUpSvg,
    Icon__xxsmall: Icon__xxsmall__arrowUpSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
